/**
 * @author Martin Leonov <martin.leonov@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

import AssertionError from 'assertion-error';

import ViewerSourceVideo from './viewer-source-video';

/**
 * @import { IViewerSourceFactory } from '../../video'
 * @import { ViewerFrameFactory } from '../frame'
 */

// TODO Unit testy.
/**
 * Továrna na zdroje funkcionalit v podobě HTML video elementů.
 * @implements {IViewerSourceFactory}
 */
export default class ViewerSourceVideoFactory {
  /**
   * Vytvoří instanci.
   * @param {ViewerFrameFactory} frameFactory
   */
  constructor(frameFactory) {
    this.frameFactory = frameFactory;
    /** @type {HTMLElement | undefined} */
    this.parentEl = undefined;
  }

  /** @type {IViewerSourceFactory['create']} */
  create() {
    if (!this.parentEl) {
      throw new AssertionError('parentEl not set');
    }
    return new ViewerSourceVideo(this.frameFactory, this.parentEl);
  }

  /** @type {IViewerSourceFactory['delete']} */
  delete(source) {
    return source.destroy();
  }

  /** @type {IViewerSourceFactory['setParentEl']} */
  setParentEl(parentEl) {
    this.parentEl = parentEl;
  }
}
